import React from 'react';
import { createModifyTableLayout } from '../modify-table-layout/modify-table-layout.esm.js';

function createConnectedModifyTableLayoutComponent(useModifyTableLayoutContext) {
  var ModifyTableLayout = createModifyTableLayout();
  function ConnectedModifyTableLayout(props) {
    var _useModifyTableLayout = useModifyTableLayoutContext(),
      services = _useModifyTableLayout.services,
      allFields = _useModifyTableLayout.allFields,
      categories = _useModifyTableLayout.categories,
      layouts = _useModifyTableLayout.layouts,
      setLayouts = _useModifyTableLayout.setLayouts,
      resources = _useModifyTableLayout.resources;
    var showModifyTableLayout = !!services;
    if (layouts === undefined || !showModifyTableLayout) {
      //Wait until the service has loaded the layouts
      return null;
    }
    return /*#__PURE__*/React.createElement(ModifyTableLayout, {
      allFields: allFields,
      layouts: layouts,
      resources: resources,
      categories: categories,
      isOpen: props.isOpen,
      onClose: props.onClose,
      onChange: setLayouts,
      onDeleteLayout: services.deleteLayout,
      onSaveLayout: services.saveLayout
    });
  }
  ConnectedModifyTableLayout.displayName = 'ConnectedModifyTableLayout';
  return ConnectedModifyTableLayout;
}

export { createConnectedModifyTableLayoutComponent };
//# sourceMappingURL=connected-modify-table-layout.esm.js.map
